/* eslint-disable */
// src/layouts/visitMachine/strategies/CashStrategy.js

/* File: src/layouts/visitMachine/strategies/<tipo>Strategy.js
 * Estrategia concreta (Tragamoneda/Pool-Tejo/Rockola/Peluchera).
 * Implementa calculate(...) para producir moneyIn/Out, netos y collected.
 * No toca la UI; sólo devuelve números/flags que luego muestra el builder.
 */

import { resolveProfitPercentage } from "./resolveProfitPercentage";

export class CashStrategy {
  calculate(machine, userInputs, visitMachineDetails, profitPercentages, isEditMode, prevRecords) {
    const keyId = Number(machine?.LocalMachineId ?? machine?.Id);

    const original = isEditMode
      ? prevRecords.find((r) => Number(r.LocalMachineId) === keyId)
      : null;

    const rawMoneyIn = userInputs[keyId]?.MoneyIn;
    const hasMoneyIn = rawMoneyIn !== null && rawMoneyIn !== undefined && rawMoneyIn !== "";
    const moneyIn = hasMoneyIn ? Number(rawMoneyIn) : null;
    const moneyCollected = hasMoneyIn ? moneyIn : null;

    const profit = resolveProfitPercentage(machine, profitPercentages, isEditMode);

    const clientAmount = moneyCollected != null
      ? (moneyCollected * (profit.ClientPercentage || 0)) / 100
      : null;
    const ownerAmount  = moneyCollected != null
      ? (moneyCollected * (profit.OwnerPercentage  || 0)) / 100
      : null;

    const collectedStyle = moneyCollected != null && moneyCollected <= 0 ? { color: "red" } : {};

    const localMachineProfitPercentageId = profit.Id ?? null;
    
    return {
      ...machine,
      LastVisitMachineId: original?.LastVisitMachineId ?? machine?.LastVisitMachineId ?? null,
      LocalMachineId:     original?.LocalMachineId || keyId,
      MachineTypeId: machine.MachineType?.Id ?? machine?.MachineTypeId ?? null,
      FormulaId: null,
      lastCreditsIn: null,
      lastCreditsOut: null,
      actualCreditsIn: null,
      actualCreditsOut: null,
      netCreditsIn: null,
      netCreditsOut: null,
      creditsCollected: null,
      moneyIn,
      moneyOut: null,
      moneyCollected,
      clientAmount,
      ownerAmount,
      collectedStyle,
      note: userInputs[keyId]?.Note || "",
      LocalMachineProfitPercentageId: localMachineProfitPercentageId,
    };
  }
}
